import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import {
  OPTIMIZELY_FLAGS_ENUM,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useOptimizelyDecisionsContext } from 'src/context/optimizely-decisions-context'
import { GoogleSearchMethods } from '@awaze/mfe-common.api.places-api'

/**
 * Determine which Google fallback method to use for the given brand.
 * We can run 3 xp's. 1 for each brand, so we can turn it off per brand.
 */
export function useGoogleFallback(brand: Brand): GoogleSearchMethods | null {
  const optiContext = useOptimizelyDecisionsContext()
  let FLAG = null

  switch (brand) {
    case 'cottages.com':
      FLAG = OPTIMIZELY_FLAGS_ENUM.AGE_ACQUISITION_GOOGLE_FALLBACK_COT
      break
    case 'hoseasons':
      FLAG = OPTIMIZELY_FLAGS_ENUM.AGE_ACQUISITION_GOOGLE_FALLBACK_HOS
      break
    case 'novasol':
      FLAG = OPTIMIZELY_FLAGS_ENUM.AGE_ACQUISITION_GOOGLE_FALLBACK_NOV
      break
  }

  if (!FLAG) {
    return null
  }
  const variationKey = optiContext?.getExperimentVariationKey(FLAG)
  if (!variationKey) {
    return null
  }

  switch (variationKey) {
    case OPTIMIZELY_VARIANT_KEYS.GOOGLE_FALLBACK_AUTOCOMPLETE:
      return 'autocomplete'
    case OPTIMIZELY_VARIANT_KEYS.GOOGLE_FALLBACK_TEXTSEARCH:
      return 'textsearch'
    case 'baseline':
      return null
    default:
      return null
  }
}
